import Api from './Api';

const getArticle = (queryObject) => {
  return Api().get(`/articles`, { params: queryObject });
};

const getSpotlightArticles = (spotlight) => {
  return Api().get(`/articles/spotlight/${spotlight}`);
};

const putArticle = (data, id) => {
  return Api().put(`/articles/${id}`, data, {
    headers: {
      'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
    },
  });
};

const postArticle = (data) => {
  return Api().post(`/articles/`, data, {
    headers: {
      'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
    },
  });
};

const getArticleIndividual = (slug) => {
  return Api().get(`/articles/${slug}`);
};

const deleteArticle = (id) => {
  return Api().delete(`/articles/${id}`);
};

const putSpotlight = (id, data) => {
  return Api().patch(`/articles/spotlight/${id}`, { spotlight: data ? true : false });
};

export {
  putArticle,
  postArticle,
  getArticleIndividual,
  getSpotlightArticles,
  getArticle,
  deleteArticle,
  putSpotlight,
};
